import { useSelector } from 'react-redux';
import { selectors as userSelectors } from '../store/CurrentUser.model';

export default function useProviderId(): number {
  return useSelector(userSelectors.getSuperAwareProviderId);
}
